import React, { Component } from 'react';
import axios from 'axios';
import { Redirect, withRouter } from 'react-router-dom';
import { ROOT_URL } from '../../config/global.js';

//Compponent
import FormLogin from '../organisms/FormLogin';


class Login extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loginStatus: this.props.loginStatus,
			redirectToSignUp: false,
			emailInput: '',
			passwordInput: '',
			verifyError: '',
			connectionError: null,
			error: null
		}

		this.handleLogin = this.handleLogin.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.confirmChange = this.confirmChange.bind(this);
	}
	componentWillMount() {
		// If the user hasn't verified his account, then call the server again
		if (this.props.loginStatus.data.length <= 0 || !this.props.loginStatus.data.verified) {
			this.props.fetchLoginStatus(); // Fetching the status from the server
		}
	}
	handleLogin(e) {
		e.preventDefault();
		const loginRequest = axios({
			method: 'post',
			url: `${ROOT_URL}/api/auth/login`,
			data: {
				email: this.state.emailInput, //daniel@frankie.se
				password: this.state.passwordInput //12345
			}
		});

		// Updates the store with the new login status
		loginRequest.then((loginRes) => {
			// Fetching the status from the server again, updating the store.
			this.props.setLoginStatus(loginRes.data);

		}).catch((error) => {
			this.setState({
				error: error.response.data.message,
				verifyError: 'form__group--error'
			});
		});
	}
	confirmChange(e) {
		// Trigger onBlur, updates the state on auto-fill events
		this.handleChange(e);
	}
	handleChange({ target }) {
		this.setState({
			[target.name]: target.value,
			verifyError: ''
		});
	}
	renderHandler(data, error) {
		if (data === undefined) { return false; }

		if (data.message === 'logged in' && data.verified) {
			return (
				<Redirect to={{
					pathname: '/bots',
					state: { from: this.props.location, storeLoginStatus: true } // This is the store state
				}} />
			)
		} else if (data.message === 'logged in' && !data.verified) { // If it is successfully logged in but the account is not verified
			return (
				<Redirect to={{
					pathname: '/verify',
					state: { from: this.props.location, storeLoginStatus: true } // This is the store state
				}} />
			)
		} else {
			return (
				<div>

					<FormLogin
						//The actual function to submit 
						handleFormSubmit={(e) => this.handleLogin(e)}

						//Heading & Text
						textHeadingOne={this.props.data.formLogin.textHeadingOne}
						textParagraph={this.props.data.formLogin.textParagraph}

						//Global
						formWrapperClassType=""
						formGroupClassType={this.state.verifyError}
						textfieldClassType=""
						textFieldForm=""
						errorMessageClassType=""
						onBlur={this.confirmChange}

						//Email
						email={this.props.data.formLogin.email}
						errorMessageEmail={this.props.data.formLogin.errorMessageEmail}
						emailInput={this.state.emailInput}
						emailOnChange={this.handleChange}

						//Password
						password={this.props.data.formLogin.password}
						errorMessagePassword={this.props.data.formLogin.errorMessagePassword}
						passwordInput={this.state.passwordInput}
						passwordOnChange={this.handleChange}

						//Forgot poassword
						forgotPassword={this.props.data.formLogin.forgotPassword}
						href={this.props.data.formLogin.forgotPasswordHref}

						//Button
						formButtonText={this.props.data.formLogin.formButtonText}
						formButtonClassType={`btn--fullWidth ${error ? 'btn--disabled' : ''}`}

						//No account
						noAccount={this.props.data.formLogin.noAccount}

					/>
				</div>


			)
		}
	}
	render() {
		const { data } = this.props.loginStatus; // Reads the store
		const { error } = this.props.loginStatus; // Reads the store

		return this.renderHandler(data, error);
	}
}

export default withRouter(Login);


// WEBPACK FOOTER //
// ./src/redux/components/templates/Login.jsx